import { Component, Input, OnInit } from '@angular/core';
import { PromotionalsSetting } from '@interfaces/promotionals-setting.model';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { GoogleTagManagerService } from '../../../../services/analytics/google-tag-manager.service';

@Component({
  selector: 'app-benefit-card',
  templateUrl: './benefit-card.component.html',
  styleUrls: ['./benefit-card.component.scss'],
})
export class BenefitCardComponent implements OnInit {
  @Input() public promotion: PromotionalsSetting;

  public readonly imagePath = '../../../assets/images/';
  public gtmNurseHotlineLinkData: string =
    'gtm.convenient_care.homepage.nurse_hotline_link';
  public gtmExternalLinkData: any;

  constructor(
    public mediaQuery: MediaObserver,
    private googleTagManagerService: GoogleTagManagerService
  ) {}

  ngOnInit() {
    this.setGtmData();
  }

  public getType(): string {
    return this.promotion.type;
  }

  public isInternal(): boolean {
    return !this.promotion.redirect_url;
  }

  public getHref(): string {
    return this.promotion.redirect_url;
  }

  public getRoute(): string {
    return '/marketing/' + this.getType();
  }

  public onPromotionalBenefitsClick(event: MouseEvent): void {
    const target = event.target || event.srcElement || event.currentTarget;
    if (
      target &&
      target['nodeName'] &&
      target['nodeName'] === 'A' &&
      this.mediaQuery.isActive('sm')
    ) {
      this.googleTagManagerService.pushToDataLayer({
        event: this.gtmNurseHotlineLinkData,
      });
    }
  }

  private setGtmData(): void {
    const gtmData = {
      event: 'gtm.convenient_care.homepage.external_link',
      convenient_care_external_link_label:
        'promotional_benefits_' + this.getType() + '_button_content',
    };
    this.gtmExternalLinkData = this.googleTagManagerService.translate(gtmData, [
      'convenient_care_external_link_label',
    ]);
  }
}
